import {
    AfterViewChecked,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {CmsComponentData} from '@spartacus/storefront';
import {Observable, Subscription} from 'rxjs';
import {distinctUntilChanged, map, switchMap} from 'rxjs/operators';

import {AimoCMSBulletinListComponent} from '../../model/cms.model';
import {AimoBulletin, AimoBulletinList} from '../../model/user.model';
import {AimoUserService} from '../../service/user/aimo-user.service';
import {RoutingService} from '@spartacus/core';

const BULLETIN_LIMIT_ON_FRONTPAGE = 3;

@Component({
    selector: 'aimo-bulletin-list-component',
    templateUrl: './aimo-bulletin-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AimoBulletinListComponent implements OnDestroy, OnInit, AfterViewChecked {
    bulletins$: Observable<AimoBulletinList>;
    data$: Observable<AimoCMSBulletinListComponent>;
    subscription: Subscription = new Subscription();
    bulletinHeightsChecked: boolean = false;
    @ViewChild('bulletinList') bulletinList: ElementRef<HTMLElement>;

    constructor(
        protected componentData: CmsComponentData<AimoCMSBulletinListComponent>,
        protected userService: AimoUserService,
        protected activatedRoute: ActivatedRoute,
        protected cdr: ChangeDetectorRef,
        protected elRef: ElementRef,
        protected routingService: RoutingService,
    ) {
        this.data$ = componentData.data$;
    }

    ngOnInit(): void {
        this.bulletins$ = this.init(this.componentData.uid === 'BulletinListComponent' ? undefined : BULLETIN_LIMIT_ON_FRONTPAGE);
    }

    ngAfterViewChecked(): void {
        if (!this.bulletinHeightsChecked && this.bulletinList?.nativeElement != null) {
            this.elRef.nativeElement.querySelectorAll('.bulletin-list .bulletin-header').forEach((bulletinTitle) => {
                if (bulletinTitle.nextSibling.offsetHeight) {
                    const parentHeight = bulletinTitle.closest('.bulletin-description-wrapper').offsetHeight;
                    const titleHeight = bulletinTitle.offsetHeight;
                    const margin = 8;
                    const lineHeight = 21;
                    const shortDescriptionHeight = parentHeight - (titleHeight + margin);
                    const newLineCount = Math.floor(shortDescriptionHeight / lineHeight);
                    const newHeight = newLineCount * lineHeight;
                    bulletinTitle.nextSibling.style.height = newHeight + 'px';
                    bulletinTitle.nextSibling.style.setProperty('-webkit-line-clamp', newLineCount);
                    const childParagraph = bulletinTitle.nextSibling.childNodes[0];
                    if (childParagraph.nodeName === 'P') {
                        childParagraph.style.height = newHeight + 'px';
                        childParagraph.style.setProperty('-webkit-line-clamp', newLineCount);
                    }
                }
            });
            this.bulletinHeightsChecked = true;
        }
    }

    init(limit?: number): Observable<{ bulletins: AimoBulletin[] }> {
        return this.routingService.getRouterState().pipe(
            map((routingData) => routingData.state.params.announcementId),
            distinctUntilChanged(),
            switchMap((categoryCode) =>
                this.userService.getActiveBulletinList(categoryCode).pipe(
                    map((list) => ({
                        ...list,
                        bulletins: list.bulletins.slice(0, limit ? limit : list.bulletins.length),
                    })),
                ),
            ),
        );
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    isExternal(data: AimoBulletin): boolean | null {
        return data?.external === 'true' || data?.external === true;
    }

    getTarget(data: AimoBulletin): string | null {
        return this.isExternal(data) ? '_blank' : null;
    }
}
